import React, { createContext, useContext, useEffect, useState } from 'react';
import { auth, db } from '../firebase';
import { onAuthStateChanged, signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { collection, query, where, getDocs } from 'firebase/firestore';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      (async () => {
        setUser(currentUser);
        setIsAdmin(false);
        if (currentUser) {
          try {
            const idTokenResult = await currentUser.getIdTokenResult();
            if (idTokenResult?.claims?.admin) {
              setIsAdmin(true);
            } else {
              // fallback: check 'admins' collection in Firestore
              const q = query(collection(db, 'admins'), where('email', '==', currentUser.email));
              const snap = await getDocs(q);
              if (!snap.empty) setIsAdmin(true);
            }
          } catch (e) {
            setIsAdmin(false);
          }
        }
        setLoading(false);
      })();
    });
    return unsubscribe;
  }, []);

  const login = (email, password) => signInWithEmailAndPassword(auth, email, password);
  const logout = () => signOut(auth);

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, isAdmin }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};
